import EntityOverviewPage from 'Components/Organisms/Entity/EntityOverviewPage/EntityOverviewPage';
import PageTemplate from 'Components/Templates/Page/Page/PageTemplate';
import { Helmet } from 'react-helmet-async';
import { ROUTES } from 'Services/Route/Route.types';

const BusinessUnitOverviewPage = () => {
    return (
        <PageTemplate>
            <Helmet>
                <title>{ ROUTES.BUSINESS_UNITS.title }</title>
            </Helmet>

            <EntityOverviewPage
                entity_name='business_unit'
            />
        </PageTemplate>
    )
}

export default BusinessUnitOverviewPage;